import React, {Component} from 'react'
import '../../../components_style/rtl_css/PatientForm.css'
import '../../../components_style/PatientForm.css'
import utils from "../../../utils/utils";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import {makeError} from "../../../components/modals/ErrorModal";
import AlertConfirm from "../../../components/modals/Confirm";
import AllUsersApi from "../../../services/ApiServices/AllUsersApi";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import SvGraphics from "../../../assets/SvGraphics";
import Error from "../../../components/single_components/Error";
import Config from "../../../config/Config";
import ReCaptcha from "../ReCaptcha";
import {authenticationService} from "../../../services/AuthenticationService";
import Translate from "../../../utils/Translate";
import {history} from "../../../utils/history";

class RecommendClinicRegComposed extends Component {

    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef()

        this.state = {
            entry: {
                ID_passport: "",
                First_name: "",
                Last_name: "",
                Email: "",
                Phone_num1: "",
                Insuring_factor: "",
                reCaptchaToken: "",
                termOfUseSigned: false,
                sendMarketOffers: false
            },
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            ID_passport: Yup.string().required(t('defaults.Registration.mandatoryField')).matches(/^\d+$/, t('defaults.Registration.digitsOnly')).test('len', t('defaults.Registration.nineCharacters'), val => val.length === 9),
            First_name: Yup.string().required(t('defaults.Registration.mandatoryField')),
            Last_name: Yup.string().required(t('defaults.Registration.mandatoryField')),
            Clinic_Code: Yup.string().required(t('defaults.Registration.mandatoryField')),
            Phone_num1:Yup.string().nullable().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only'),
            Insuring_factor: Yup.string().required(t('defaults.Registration.mandatoryField')),
            Email: Yup.string().required(t('defaults.Registration.mandatoryField')).matches(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, t('defaults.Registration.invalidMail')).nullable(),
            /*
              Phone_num1: Yup.string().nullable().required('This field is mandatory').matches(/^\d+$/, 'The field should have digits only')
  */
            confirmEmail: Yup.string().required(t('defaults.Registration.mandatoryField'))
                .oneOf([Yup.ref('Email'), null], t('defaults.Registration.emailMustMatch')),

        })
        let errors = await validationHelper.validate(this.state.entry, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })

    }

    componentDidMount = async () => {
        /*
                        await this.initValidation()
        */
    }


    onValueChange = async (name, value) => {
        let {entry, validationSchema} = this.state
        if (name === "Email" && value === "") {
            value = null
        }
        utils.set(entry, name, value)
        let errors = await validationHelper.validate(entry, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }
    saveEntry = async () => {
        await this.recaptchaRef.reset()
        await this.recaptchaRef.execute()
    }

    submitData = async (reCaptchaToken) => {
        let {t} = this.props
        await this.initValidation()

        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            await makeError({
                proceedLabel: 'Ok',
                options: {
                    title: t('defaults.Registration.couldNotSaveData'),
                }
            }, [t('defaults.Registration.fillRequiredFields')]);
            return;
        }
        let {entry} = this.state

        if (!entry.termOfUseSigned) {
            let confirm = await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    proceedLabel: t('defaults.rst_pwd.Ok'),
                    title: t('defaults.crt_pwd.termofuse_title'),
                }
            }, t('defaults.crt_pwd.termofuse_req'))
            return
        }

        entry = utils.ObjectEmptiesToNulls(entry)
        entry = utils.removeEmptyOrNull(entry)
        // let confirm = await AlertConfirm({
        //     options: {
        //         title: `Registration details`,
        //     }
        // }, `Are you sure you wish to create a new user in leumit?`)
        // if (confirm) {

        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
        }
        entry['reCaptchaToken'] = reCaptchaToken

        let response = await AllUsersApi.selfRegisterRecommend(entry)

        if (response && response.data.status === 200) {
            let responseLogin = await authenticationService.PatientLogin(entry.ID_passport, entry.Phone_num1, reCaptchaToken);
            if (responseLogin) {
                let data = {Phone_num1: entry.Phone_num1, ID_passport: entry.ID_passport}
                this.setState({entry: {}})
                this.props.history.push({
                    pathname: `/login`,
                    state: {
                        data,
                        from: {
                            fromPath: `/register_recommend`,
                        }
                    },
                })
            }
        } else {
            let message = t('defaults.Registration.patientExists')
            if (response.data.status === 300) {
                message = t('defaults.Registration.ClinicDoesntExists')
            }  else if (response.data.status === 260) {
                message = t('defaults.Registration.patientEmailExists')
            }
            let confirm = await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    proceedLabel: t('patient_boarding.ok'),
                    title: t('defaults.Registration.registration_info'),
                }
            }, message)
        }
        // }
    }

    goBack() {
        this.props.history.push('/login')
    }


    componentDidUpdate() {
        const myInput = document.getElementById('Email-Confirm');
        myInput.onpaste = e => e.preventDefault();
    }

    setTermsOfUseSigned = async (e) => {
        let {entry} = this.state
        entry.termOfUseSigned = !entry.termOfUseSigned
        this.setState({entry})
    }
    setSendMerketOffers = async (e) => {
        let {entry} = this.state
        entry.sendMarketOffers = !entry.sendMarketOffers
        this.setState({entry})
    }

    async onSelectFlag(e) {
        e = e && e.length>0?e:"he"
        localStorage.setItem('language', e)
        let lang = Translate.getLanguage(e);
        let language = await Translate.setLanguageLocal(lang);
        const {i18n} = this.props;
        await i18n.changeLanguage(language);
        if (Translate.rtl.includes(language)) document.getElementsByTagName("html")[0].setAttribute("dir", "rtl")
        else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr")
    }


    goToLogIn = () => {
        history.push({
            pathname: '/login',
            state: {
                from: {
                    fromPath: `/register_recommend`,
                }
            },
        })
    }

    render() {
        let {errorsOnSave, entry} = this.state
        let {t} = this.props
        return (
            <div className={"login-page"}>
                {/*<div className={'sade-right-changeLang'}>
                    <ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-navbar-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />
                </div>*/}
                <div className={'sade-login-logo-container'}>
                    <SvGraphics svgname={'asaya_logo'} className={'sade-asaya-login-logo'}/>
                    {/*<ReactFlagsSelect selectButtonClassName={'language-select-button'}
                                      className={'sade-right-language-content'}
                                      placeholder={t('patient_boarding.choose_language')}
                                      defaultCountry={Translate.getCurrentCountry()}
                                      countries={Translate.getCountries()} showSelectedLabel={true}
                                      showOptionLabel={true} selectedSize={14}
                                      selected={Translate.getCurrentCountry(localStorage.getItem('language'))}
                                      onSelect={e => this.onSelectFlag(e)}
                                      customLabels={{
                                          "US": "EN",
                                          "IL": "עב",
                                      }}
                    />*/}
                </div>
                <div className={'sade-registration-main-board'}>
                    <div className={'sade-welcome-label'}>{t('defaults.Registration.welcome_asaya')}</div>
                    <div className={'sade-login-label2'}>{t('defaults.Registration.fast_applciation')}</div>
                    <br/>
                    <div className={'sade-login-label3'}>{t('defaults.Registration.mail_notice')}</div>
                    <div className={'sade-Pain-reg-form'}>
                        <div className={'sade-Pain-registration-inputs-flex'}>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'First_name')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'First_name')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.First_name')}
                                           name={"First_name"}
                                           defaultValue={entry.First_name}
                                           onChange={(event) => this.onValueChange("First_name", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'First_name') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Last_name')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Last_name')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Last_name')}
                                           name={"Last_name"}
                                           defaultValue={entry.Last_name}
                                           onChange={(event) => this.onValueChange("Last_name", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Last_name') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                        </div>

                        <div className={'sade-Pain-registration-inputs-flex'}>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'ID_passport')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'ID_passport')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           name={"ID_passport"}
                                           value={entry.ID_passport}
                                           placeholder={t('defaults.Registration.ID_passport')}
                                           maxLength={9}
                                           onChange={(event) => this.onValueChange("ID_passport", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'ID_passport') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'idPass'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'Phone_num1')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Phone_num1')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Phone')}
                                           name={"Phone_num1"}
                                           value={entry.Phone_num1}
                                           onChange={(event) => this.onValueChange("Phone_num1", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Phone_num1') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'smartPhone'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                        </div>
                        <div className={'sade-Pain-registration-inputs-flex'}>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true} errorMessage={utils.get(this.state.errorsOnSave, 'Email')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Email')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Email')}
                                           name={"Email"}
                                           defaultValue={entry.Email}
                                           onChange={(event) => this.onValueChange("Email", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Email') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'email-icon'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>
                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'confirmEmail')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'confirmEmail')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.confirmEmail')}
                                           name={"Email"}
                                           id={"Email-Confirm"}
                                           defaultValue={entry.confirmEmail}
                                           onChange={(event) => this.onValueChange("confirmEmail", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Email') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'email-icon'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>


                        </div>
                        <div className={'sade-Pain-registration-inputs-flex'}>

                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Insuring_factor')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Insuring_factor')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <select className={'selectBoxRegistrationApproving'} id="InsuranceType"
                                            name="InsuranceType"
                                            defaultValue={entry.Insuring_factor}
                                            onChange={(event) => this.onValueChange("Insuring_factor", event.target.value)}>
                                        <option value="" disabled
                                                selected>{t('patient_self_boarding.Insurance')}</option>
                                        <option value={"1"}>{t('patient_self_boarding.Maccabi')}</option>
                                        <option value={"2"}>{t('patient_self_boarding.Clalit')}</option>
                                        <option value={"3"}>{t('patient_self_boarding.Leumit')}</option>
                                        <option value={"4"}>{t('patient_self_boarding.Meuhedet')}</option>
                                        <option value={"5"}>{t('patient_self_boarding.InsuranceCompany')}</option>
                                        <option value={"6"}>{t('patient_self_boarding.IDF')}</option>
                                        <option value={"7"}>{t('patient_self_boarding.MinistryOfDefence')}</option>
                                        <option value={"8"}>{t('patient_self_boarding.None')}</option>
                                        <option value={"9"}>{t('patient_self_boarding.PalestinianAuthority')}</option>
                                        <option value={"10"}>{t('patient_self_boarding.other')}</option>
                                    </select>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'Insuring_factor') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'insurance'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                            <div className={'sade-Pain-registration-input-svg'}>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'Clinic_Code')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'Clinic_Code')}/>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-fields"}
                                           placeholder={t('defaults.Registration.Clinic_Code')}
                                           name={"Clinic_Code"}
                                           id={"Clinic_Code"}
                                           defaultValue={entry.Clinic_Code}
                                           onChange={(event) => this.onValueChange("Clinic_Code", event.target.value)}
                                    />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'lock') ? "input-pic-reg2" : "input-pic-reg"}
                                        svgname={'pass1'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                            </div>

                        </div>

                        <div className={"login-input-wrapper form-group sade-login-form-checkboxes"}
                             style={{display: 'flex'}}>
                            <input
                                type="checkbox"
                                onChange={e => this.setTermsOfUseSigned(e)}
                                style={{marginTop: '8px', width: '19px', height: '19px', transform: 'scale(1)'}}
                            />
                            <label className={'termsofuse'}>
                                {t('defaults.crt_pwd.termOfUse')}
                                <a target="_blank" style={{color: '#000000'}}
                                   href="https://sade-terms.s3.eu-central-1.amazonaws.com/%D7%AA%D7%A0%D7%90%D7%99+%D7%A9%D7%99%D7%9E%D7%95%D7%A9++ASAYApp+R01.pdf">
                                    {t('defaults.crt_pwd.termOfUse1')}</a>
                                {t('defaults.crt_pwd.and')}
                                <a target="_blank" style={{color: '#000000'}}
                                   href="https://sade-terms.s3.eu-central-1.amazonaws.com/%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA+%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA++ASAYApp+R01.pdf">
                                    {t('defaults.crt_pwd.termOfUse2')}</a>
                                {t('defaults.crt_pwd.termOfUse3')}</label>
                        </div>
                        <div className={"login-input-wrapper form-group sade-login-form-checkboxes2"}
                             style={{display: 'flex'}}>
                            <input
                                type="checkbox"
                                onChange={e => this.setSendMerketOffers(e)}
                                style={{marginTop: '8px', width: '19px', height: '19px', transform: 'scale(1)'}}
                            />
                            <label className={'termsofuse'}>{t('defaults.Registration.marketsOffer')} </label>
                        </div>
                        <div className="form-group leumit-login-form-group">
                            <button className="sade-registration-form-button"
                                    onClick={this.saveEntry.bind(this)}>{t('defaults.Registration.save')}</button>
                        </div>

                        <div className={'sade-login-footer-container'} onClick={() => this.goToLogIn()}>
                            <a>{t('defaults.login.login')}</a>
                        </div>
                    </div>

                    <div className={'leumit-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.Registration.reg_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>

                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}

let RecommendClinicReg = compose(
    withTranslation()
)(RecommendClinicRegComposed)
export default RecommendClinicReg;
